export const emailRegex =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>().,;\s@"]+\.{0,1})+[^<>().,;:\s@"]{30,})$/
export const personNameFilter = /[^a-zA-ZA-öA-ž- ]/g
// eslint-disable-next-line
export const phoneFilter = /[^\d\+\-()]+/g
export const noControlsFilter = /[[:cntrl:]]/g
export const unsignedNumberFilter = /\D|^0/g
export const phoneForValidation = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4,10}\)?)?$/
